import type { AgentSessionMeta } from "../../slices/ui";

// The chat list's live state (omega-ai-agent-service src/sessionListState.ts): a Hot Session (podBound) has its Account's pod
// running its Devcontainer; a held row's Devcontainer Volumes are held by another Account's pod. An old server sends neither,
// and the list then renders with no chip and no held marker. Neither changes the order of the list.

// The chat list has one order: the newest last message first (Terms: Hot Session in omega-ai-agent-service/pages/agent-service/terms.html;
// omega-ai-agent-service/src/sessionListState.ts decorateRow). podBound only means the Account's pod could serve the row, which
// holds for every chat of the pod's app while the pod lives, so it never moves a row (the browser chat sat 28th under 28 idle
// chats, 2026-10-26). The server already sends this order; sorting here keeps the sidebar to it. Array.prototype.sort is stable,
// so rows with the same last message keep the order they came in.
export const byRecency = (rows: AgentSessionMeta[]): AgentSessionMeta[] =>
  [...rows].sort((a, b) => b["last-message-at"] - a["last-message-at"]);

// The Devcontainer's name is the server's containerName and nothing else: a path or a uuid is never parsed into a guess.
// A row with no devcontainer is the Account's own chat (Default); a named-less container has no chip.
export const containerLabel = (s: AgentSessionMeta): string | null => s.containerName ?? (s.devcontainer ? null : "Default");

const HELD: Record<string, string> = {
  active: "In use by another account's agent: working now",
  idle: "In use by another account's agent: it will step aside when you open this chat",
};
export const heldLabel = (s: AgentSessionMeta): string => (s.volumeHeld && HELD[s.volumeHeld]) || "";
